<div class="progress-bar-container">
  @for (step of steps; track step; let index = $index) {
    <div
      [ngClass]="{ 'last-step': index === steps.length - 1, 'step-done': currentStep.id > step.id }"
      class="progress-step-container"
      >
      <div class="progress-step-item">
        <div class="progress-step-ball"></div>
        <div class="progress-step-label">{{ step.name }}</div>
      </div>
      @if (index !== steps.length - 1) {
        <div>
          <div class="progress-step-bar"></div>
        </div>
      }
    </div>
  }
</div>
